import { useTranslation } from 'react-i18next';

import { Label, LABEL_TYPE } from '@/components/generic';
import { formatDate, formatDateWithTranslation } from '@/helpers/date';
import { CalendarLeftArrow, CalendarRightArrow } from '@/resources';

type DatePickerCustomHeaderProps = {
  date: Date;
  decreaseMonth: () => void;
  increaseMonth: () => void;
  increaseYear: () => void;
  decreaseYear: () => void;
  pickOnlyYear: boolean;
};

export const DatePickerHeader = ({
  date,
  decreaseMonth,
  increaseMonth,
  increaseYear,
  decreaseYear,
  pickOnlyYear
}: DatePickerCustomHeaderProps) => {
  const { t } = useTranslation('common');

  return (
    <div
      className={`m-auto flex h-10 w-60 items-center justify-between px-6 ${
        pickOnlyYear ? 'pb-3 pt-4' : 'pb-3 pt-4'
      }`}>
      <CalendarLeftArrow
        onClick={pickOnlyYear ? decreaseYear : decreaseMonth}
        className='cursor-pointer text-sm'
      />
      <Label
        text={
          pickOnlyYear
            ? (formatDate(date, { year: 'numeric' }) ?? '')
            : `${formatDateWithTranslation(date, t, { month: 'long' })}, ${formatDate(date, { year: 'numeric' })}`
        }
        type={LABEL_TYPE.PARAGRAPH1}
        className='!font-medium'
      />
      <CalendarRightArrow
        onClick={pickOnlyYear ? increaseYear : increaseMonth}
        className='cursor-pointer text-sm'
      />
    </div>
  );
};
